import React, { Component } from 'react';
import { change } from 'redux-form';
import { withStyles } from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';

import { Editor } from 'components/flink-components';
import { MaterialFaIcon } from 'utils';

const styles = (theme) => ({
  wrapper: {
    position: 'relative',
  },
  popup: {
    position: 'absolute',
    zIndex: 10,
    background: '#fff',
    width: '100%',
    border: '1px solid #eee',
    borderRadius: '4px',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    paddingBottom: '4rem',
  },
  editorWrapper: {},
  editor: {
    height: '250px',
    padding: '1rem',
  },
  actions: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    zIndex: 11,
    display: 'flex',
  },
  finishButton: {
    marginRight: 10,
  },
});

class FieldWysiwygShow extends Component {

  onFinish = () => {
    this.props.handleShowValue()
  };

  onEditorChange = (html) => {    
  };

  render() {
    const { classes, addAudioButton, dataPrettyValue } = this.props;

    return (
      <div className={classes.wrapper}>        
          <div className={classes.popup}>
            <Editor
              className={classes.editor}
              initialValue={dataPrettyValue || ''}
              changeHandler={this.onEditorChange}
              withAddAudio={addAudioButton}
            />
            <div className={classes.actions}>
              <Fab
                className={classes.finishButton}
                onClick={this.onFinish}
                color="primary"
                size="medium"
              >
                <MaterialFaIcon icon="check" />
              </Fab>
            </div>
          </div>
        
      </div>
    );
  }
}

FieldWysiwygShow.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(
  connect(null, { change }),
  withStyles(styles)
)(FieldWysiwygShow);
